import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useReveal } from '../../hooks/useReveal';
import CourseMeta from './CourseMeta';
import CourseHighlights from './CourseHighlights';

export default function CourseCard({ course, index }) {
  const { ref, inView } = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${index * 120}ms` }}
      className={`reveal ${inView ? 'in-view' : ''} lift rounded-3xl bg-white border border-[var(--pca-border)] p-7 md:p-9 relative overflow-hidden`}
    >
      <div className="absolute -top-16 -right-16 w-52 h-52 rounded-full bg-blue-50" />
      <div className="relative">
        <span className="section-eyebrow !bg-white !border !border-[var(--pca-border)] !text-slate-500 !tracking-normal !text-[11px] !font-medium">
          {course.tag}
        </span>
        <div className="mt-5 flex items-baseline gap-3">
          <h3 className="text-[34px] md:text-[38px] font-extrabold text-[#0B2E6E]">{course.code}</h3>
          <span className="text-slate-500">· {course.title}</span>
        </div>
        <p className="mt-3 text-slate-600 max-w-lg">{course.desc}</p>

        <CourseMeta course={course} />
        <CourseHighlights eligibility={course.eligibility} highlights={course.highlights} />

        <div className="mt-7 flex flex-wrap gap-3">
          <a href="#admissions" className="btn-primary">Apply Now <ArrowRight size={16} /></a>
          <a href="#about" className="btn-outline">Learn More</a>
        </div>
      </div>
    </div>
  );
}
